import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GamesService {

  constructor(private http: HttpClient) { }

  getGameList(data: { Token: string }) {
    return this.http.post<any>('/api/Game/GetGameList', data);
  }

  vacuumLogin(paramval) {
    return this.http.post<any>('/api/User/VacuumPlayLogin', paramval);
  }
  logOut(paramval?: any) {
    return this.http.post<any>('/api/User/LogOut', JSON.stringify(paramval));
  }
  getChipSettingList() {
    return this.http.get<any>('/api/Game/GetChipSettingList');
  }
  AddUpdateChipsSetting(paramval?: any) {
    return this.http.post<any>('/api/Game/AddUpdateChipsSetting', JSON.stringify(paramval));
  }
  getConfig() {
    return this.http.get<any>('/api/User/GetConfig');
  }
  getLiability(data) {
    return this.http.post<any>('/api/User/GetLiability', data);
  }
  CheckGameStatus(data){
    return this.http.post<any>('/api/Game/CheckGameStatus', data);
  }

  Favorite(paramval) {
    return this.http.post<any>('/api/Game/Favorite', paramval);
  }

  getGameUrls(){
    var result= this.http.get<any>('/api/Game/GetSettingsUrls');
    console.log("result", result);
    return result;
  }

}
